import { React, useState } from 'react'
import { Typography, Grid, Box } from '@material-ui/core';
import WarehouseCard, { WarehouseCardSkeleton } from './WarehouseCard';
import AddIcon from '@material-ui/icons/Add';
import { ButtonSuccess } from '../../shared/components/ButtonSucces';
import WarehouseForm from  './WarehouseForm';
import useWarehouse from './../../hooks/useWarehouse';

const Warehouse = ({ warehouse }) => {
    const [modalState, setModalState] = useState(false);

    const handleCancel = () => {
        setModalState(false);
    }
    const handleOpen = () => {
        setModalState(true);
    }

    const { warehouses, isLoading } = useWarehouse();
   
    return (
        <div>

            {modalState && <WarehouseForm visible={modalState} handleCancel={handleCancel} />}

            <Grid container justify="space-between">
                <Grid item>
                    <Typography variant="h6" color="textSecondary" gutterBottom>
                        LISTE DES WAREHOUSE
                    </Typography>
                </Grid>
                <Grid item >
                    <ButtonSuccess size="small"
                        variant="contained"
                        color="primary"
                        onClick={handleOpen}
                        startIcon={<AddIcon />}
                    >
                        Add Warehouse
                    </ButtonSuccess>
                </Grid>
            </Grid>
            <Box style={{ height: 20 }} />
            <Grid container spacing={4} >
                {isLoading ?
                    <WarehouseCardSkeleton />
                    : warehouses && warehouses.map((warehouse, idx) => (
                        <Grid key={idx} item xs={12} sm={6} md={4}>
                            <WarehouseCard
                            style={{overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap'}}
                            warehouse = {warehouse}
                            />
                        </Grid>
                    ))}
            </Grid>
        </div>
    )
}

export default Warehouse